import { ApiClient } from '@webapp/core/services/ApiClient'
import { budgetRepository } from '@webapp/platform/budgets'
import { accountRepository } from '@webapp/platform/finance'
import { OrderRepository } from './OrderRepository'

export const orderRepository = new OrderRepository({
  httpClient: ApiClient,
  budgetRepository,
  accountRepository,
})
